import { useEffect } from "react";
import { BRAND } from "@/lib/site";

export function useSEO(title, description) {
  useEffect(() => {
    const fullTitle = `${title} — ${BRAND.name}`;
    document.title = fullTitle;

    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    window.scrollTo(0, 0);
  }, [title, description]);
}
